import { HStack, IconButton } from '@chakra-ui/react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoMdCheckmark } from 'react-icons/io';
import { LuMinus } from 'react-icons/lu';

import Tooltip from 'components/v4/Tooltip';
import ActionsCellWrapper from 'components/tables/AGGrid/ActionsCellWrapper';

const booleanCellRenderer = (params) =>
    params.value ? (
        <IoMdCheckmark fontSize="large" />
    ) : (
        <LuMinus fontSize="large" />
    );

/**
 * Builds the AG Grid column definitions for the Engines table.
 *
 * @param {object}   params
 * @param {boolean}  params.darkMode      Current dark mode state.
 * @param {function} params.onViewEngine  Called with the row data when the view action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getEngineTableColumns = ({ darkMode, onViewEngine }) => [
    {
        headerName: 'ID',
        field: 'id',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        minWidth: 150,
        sort: 'asc',
    },
    {
        headerName: 'Last Heartbeat',
        field: 'lastActive',
        minWidth: 180,
        valueFormatter: (params) =>
            params.value ? new Date(params.value).toLocaleString() : '',
    },
    {
        headerName: 'Last Process Identifier',
        field: 'lastProcessIdentifier',
        minWidth: 200,
    },
    {
        headerName: 'Last Process Type',
        field: 'lastProcessType',
        minWidth: 180,
    },
    {
        headerName: 'Details',
        field: 'details',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Active',
        field: 'isActive',
        width: 120,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        cellRenderer: booleanCellRenderer,
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsCellWrapper>
                <HStack
                    spacing={0}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                    height="100%">
                    <Tooltip label="View Engine">
                        <IconButton
                            icon={
                                <BsThreeDotsVertical
                                    fill={darkMode ? 'white' : 'black'}
                                />
                            }
                            aria-label="View"
                            variant="ghost"
                            onClick={() => {
                                onViewEngine(params.data);
                            }}
                            _hover={{
                                bg: darkMode
                                    ? 'whiteAlpha.200'
                                    : 'blackAlpha.100',
                            }}
                            _active={{
                                bg: darkMode
                                    ? 'whiteAlpha.300'
                                    : 'blackAlpha.200',
                            }}
                            _focus={{ boxShadow: 'none' }}
                        />
                    </Tooltip>
                </HStack>
            </ActionsCellWrapper>
        ),
    },
];
